import { parseYMDLocal } from "./dateLocal";

/** Per-day rates from booking-quote (top-level or nested in price_breakdown). */
export function getDayBreakdown(quote) {
  if (!quote) return [];
  return quote.day_breakdown ?? quote.price_breakdown?.day_breakdown ?? [];
}

/** Listed / promotional rate vs current catalog rate. */
export function getListPrice(vehicle, quote) {
  const current = Number(vehicle?.daily_rate ?? 0);
  const original = Number(vehicle?.original_rate ?? 0);
  if (original > current) {
    return { value: original, current, isPromo: true };
  }
  const listed = Number(quote?.listed_daily_rate ?? current);
  return { value: listed, current, isPromo: false };
}

export function formatBreakdownDate(isoDate) {
  const d = parseYMDLocal(isoDate);
  if (!d) return isoDate;
  return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}

export const RATE_VARIANCE_HINT = "Rates vary by date based on demand.";
